import TextField from "../../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue"
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import PerfilService from "../../../../services/PerfilService";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";
import LoadingBlue from "../../../../components/fields/loading-blue/LoadingBlue";
export default {
    name:"DialogFormEditar",
    components:{
        TextField,
        ConfirmPasswordDialog,
        PerfilService,
        FormDialog,
        SnackBarModule,
        TextAreaField,
        LoadingBlue
    },
    mixins:[AssinaturaMixin,SnackbarMixin ],
    props: {
        perfilid: {
            required: true,
        },
        activeDialog: {
            type: Boolean,
            default: false,
        }
    },

    data: () => ({
        data: [],
        errors: [],
        form: {},
        formEdit:{},
        formTitle:'Editar',
        perfiSelectedlid:0,
        disabled: {
            nome: false,
            perfil: false,
            permissoes:false,
        },
        loading: {
            modal:false,
            table: false,
        },
        dialogShow: {
            associarPerfil: false,
            editPerfil: false,
            funcionalidades: false,
        },
        formValid: true,
        showFormDialog: false,
        activeBtnDialog:false,
        showDialogConfirmPassword: false,
        formConfirmPassword: {
            password: "",
        },
        send: {
            function: () => {},
            params: null,
        },

        perfil: [],
    }),
    created() {
       this.initializeForm();
    },
    watch: {
        activeDialog() {
            this.loading.modal = false;
            if (this.perfilid) {

                this.showFormDialog = !this.showFormDialog;
                this.loadPerfil(this.perfilid);
            }
        },
    },
    goTo(path) {
        this.$router.push(path);
    },
    methods: {
        initializeForm() {
            this.form = {
                nome: '...',
                hierarquia: '',
                descricao: '...',
            };
        },
        async loadPerfil() {
            await PerfilService.showPerfil(this.perfilid).then((res) => {
                this.form = {
                    id:res.content.res.id,
                    nome: res.content.res.nome,
                    descricao: res.content.res.descricao,
                    hierarquia: res.content.res.hierarquia.toString(),
                };
                this.loading.modal = true;
            });
        },

        async save() {
          const data = await PerfilService.updatePerfil(this.form);
          if(data.error === true) {
              //return this.form = [];
                SnackBarModule(data.message,'error');
          } else {
              SnackBarModule('Atualizado com sucesso!','success');
              this.$router.go(this.$router.currentRoute)

          }

        },
        validaForm() {
            if(this.$refs.form.validate()) {
                return this.save();
            }
        },
        getEditData() {

        },
        closed() {

            this.$emit("closed");
        },
    }
}